import { defineMessages } from "@/i18n";
import en from "./en";

export const panelsTasksMessages = defineMessages("panels-tasks", en);
